import { ConfigTheme } from '../../_core/types/theme/ConfigTheme.type';
import howItWorks from './how-it-works.timesy';
import about from './about.timesy';
import home from './home.timesy';
import general from './general.timesy';
import policies from './policies.timesy';
import auth from './auth.seeer';
import payment from './payment.seeer';
import profile from './profile.seeer';
import notification from './notification.seeer';

const theme: ConfigTheme = {
  howItWorks,
  about,
  home,
  general,
  policies,
  auth,
  payment,
  profile,
  notification,
};

export default theme;
